import { Component } from '@angular/core';
import { Links } from './links';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';

@Component({
    template: require('./requests.component.html'),
    styles: [require('./requests.component.scss')]
})

export class RequestsComponent 
{
    data:any = [];
    dialogRef;
    id:any;
    navLinks = [
            new Links('1','create',"add_user_info",'create/'),
            new Links('2','return','add_return_item_details','return/'),
            new Links('3','conform_details','confirm_all_pickup','confirm/')
        ];
    userData:any;
    orderId:any;
    isApprover:boolean = false;
    constructor(private router: Router,private commonService : CommonService,private route: ActivatedRoute,private sessionHandler:SessionHandler,
    private http:HttpService,private dialog: MdDialog) {
        
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.commonService.viewData.subscribe((value) => {
            this.data = value;
            this.setlinks(this.data);
            });
        }

        public setlinks(data){
            if(data && data.orderId){
                this.orderId = data.orderId;
                this.navLinks = [
                    new Links('1','create',"add_user_info",'create/'+data.orderId),
                    new Links('2','return','add_return_item_details','return/'+data.orderId),
                    new Links('3','Confirm Details','confirm_all_pickup','confirm/'+data.orderId)
                ];
                // if(this.userData.role && this.userData.role.length > 0){
                //     for(let u in this.userData.role){
                //         if(this.userData.role[u] == 'APPROVER') {
                //             this.isApprover = true;
                //         }
                //     }
                // }
            }
        }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt/requests.component.ts